<template>
  <div class="pe-input-wrapper" :class="{ 'pe-input-disabled': disabled }">
    <input
      ref="inputRef"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :inputmode="computedInputMode"
      class="pe-input"
      @input="handleInput"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />
    
    <div v-if="$slots.append" class="pe-input-append">
      <slot name="append"></slot>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  modelValue: { type: [String, Number], default: '' },
  type: { type: String, default: 'text' },
  placeholder: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'blur', 'focus', 'change']);

const inputRef = ref(null);

// Lógica automática para inputmode en móviles
const computedInputMode = computed(() => {
  if (props.type === 'number') return 'numeric';
  if (props.type === 'email') return 'email';
  if (props.type === 'tel') return 'tel';
  return 'text';
});

const handleInput = (event) => {
  let val = event.target.value;
  
  // Si es número, tratamos de emitir número (opcional, depende de tu gusto)
  // if (props.type === 'number' && val !== '') val = Number(val);
  
  emit('update:modelValue', val);
};

// Exponer el foco para uso externo
defineExpose({
  focus: () => inputRef.value?.focus(),
  blur: () => inputRef.value?.blur()
});
</script>

<style scoped>
.pe-input-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}

/* Para navegadores basados en WebKit (Chrome, Safari, Edge) */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Para Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>